import React from "react"
import {Box, Card, TextField, Typography} from "@mui/material"
import {Controller, useFormContext} from "react-hook-form"
import CalendarTodayIcon from "@mui/icons-material/CalendarToday"

import {OfferFormDataV2} from "./offerFormValidation"

import {colors} from "@indebted/theme/colors"

function OfferPeriodCard() {
	const {
		control,
		clearErrors,
		formState: {errors},
	} = useFormContext<OfferFormDataV2>()

	return (
		<Card
			sx={{
				backgroundColor: colors.gray["50"],
				border: `1px solid ${colors.gray["200"]}`,
				borderRadius: "0.25rem",
				mb: "1.5rem",
				p: "1rem",
			}}
			elevation={0}
		>
			<Box display="flex" flexDirection="column" gap="1rem">
				<Box display="flex" alignItems="flex-start" gap="0.5rem">
					<CalendarTodayIcon sx={{fontSize: "1.5rem", mt: "0.125rem", color: colors.warmBlue["900"]}} />
					<Box>
						<Typography
							sx={{fontSize: "1rem", fontWeight: 500, color: "rgba(0,0,0,0.87)", lineHeight: 1.334}}
						>
							Offer period
						</Typography>
						<Typography
							sx={{
								fontSize: "0.875rem",
								fontWeight: 400,
								color: colors.gray["500"],
								lineHeight: 1.43,
								mt: "0.5rem",
							}}
						>
							This offer will be available to the customer in the given time period.
						</Typography>
					</Box>
				</Box>
				<Box display="grid" gridTemplateColumns="1fr 1fr" gap="1rem">
					<Controller
						name="startDate"
						control={control}
						render={({field}) => (
							<TextField
								{...field}
								onChange={(e) => {
									field.onChange(e)
									if (e.target.value) {
										clearErrors("startDate")
									}
								}}
								label="Start date *"
								type="date"
								slotProps={{inputLabel: {shrink: true}}}
								error={!!errors.startDate}
								helperText={errors.startDate?.message}
								fullWidth
								size="small"
							/>
						)}
					/>
					<Controller
						name="endDate"
						control={control}
						render={({field}) => (
							<TextField
								{...field}
								onChange={(e) => {
									field.onChange(e)
									if (e.target.value) {
										clearErrors("endDate")
									}
								}}
								label="End date *"
								type="date"
								slotProps={{inputLabel: {shrink: true}}}
								error={!!errors.endDate}
								helperText={errors.endDate?.message}
								fullWidth
								size="small"
							/>
						)}
					/>
				</Box>
			</Box>
		</Card>
	)
}

export {OfferPeriodCard}
